import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import * as option from "@/models/configurator/configurator_options";
import { FabricSwatch } from "@/models/products/fabric";
import { LayoutStore, ShapeStore, CanopyStore } from "@/mixins/store";
import FabricService from "@/services/fabric_service";
import { fabricTextureKey } from "@/helpers/fabric";
@Component
export class CanopyRules extends mixins(LayoutStore, ShapeStore, CanopyStore) {
  protected selectedMainCanopy: option.Panel | null = null;
  protected selectedAlternatingPanelType: option.AlternatingPanel | null = null;
  protected selectedVentMiddle: option.Panel | null = null;
  protected selectedAlternatingVentType: option.AlternatingPanel | null = null;

  // TODO: FUMBSD-653 -- QA! - build out the alternating double vent type handlers.
  protected selectedRib: option.Rib | null = null;
  //protected lastRibFabric: FabricSwatch | null = null;
  protected lastBindingFabric: FabricSwatch | null = null;
  protected fabricService = new FabricService();
  protected ribAutoSwitchedToGrommets = false;
  protected ribBeforeAutoSwitch: option.Rib | null = null;
  protected suppressRibWatch = false;

  // get ribFabricSwatch(): FabricSwatch | null {
  //   return this.ribFabric ? this.ribFabric : this.lastRibFabric;
  // }

  created(): void {
    this.selectedMainCanopy = this.mainCanopy;
    if (this.selectedMainCanopy === option.Panel.Alternating) {
      this.selectedAlternatingPanelType = this.mainFabric.length > 2 ? option.AlternatingPanel.Four : option.AlternatingPanel.Two;
    }

    this.selectedVentMiddle = this.ventMiddle;
    if (this.selectedVentMiddle === option.Panel.Alternating) {
      this.selectedAlternatingVentType = this.ventMiddleFabric.length > 2 ? option.AlternatingPanel.Four : option.AlternatingPanel.Two;
    }
  }

  get bindingFabricSwatch(): FabricSwatch | null {
    return this.bindingFabric ? this.bindingFabric : this.lastBindingFabric;
  }

  protected async removeBinding(): Promise<void> {
    if (this.bindingFabric) {
      this.lastBindingFabric = this.bindingFabric;
    }
    this.addBindingFabric(null);
    await this.$viewer.ChangeBindingFabric(null);
  }

  @Watch("selectedMainCanopy")
  protected async selectMainCanopy(): Promise<void> {
    if (this.selectedMainCanopy) {
      if (this.selectedMainCanopy === option.Panel.Solid) {
        this.selectedAlternatingPanelType = null;
      }
      this.addMainCanopy(this.selectedMainCanopy);
      if (
        this.selectedMainCanopy === option.Panel.Solid &&
        this.mainFabric[1]
      ) {
        this.addMainFabric([this.mainFabric[0]]);
        await this.$viewer.ChangeCanopyFabric(
          this.mainFabric[0].fabric_scale,
          fabricTextureKey(this.mainFabric[0])
        );
      }
      // Valance length is now independent of main canopy panel count.
      // Users add/remove valance fabrics explicitly via the valance UI.
    }
  }

  @Watch("selectedAlternatingPanelType")
  protected async selectAlternatingPanelType(): Promise<void> {
    if (!this.selectedAlternatingPanelType) return;

    this.selectedMainCanopy = option.Panel.Alternating;
    this.addMainCanopy(this.selectedMainCanopy);

    if (this.selectedAlternatingPanelType === option.AlternatingPanel.Two && this.mainFabric[2]) {
      this.addMainFabric([this.mainFabric[0], this.mainFabric[1]]);
      await this.$viewer.ChangeCanopyFabric(
        this.mainFabric[0].fabric_scale,
        fabricTextureKey(this.mainFabric[0]),
        this.mainFabric[1].fabric_scale,
        fabricTextureKey(this.mainFabric[1])
      );
    }
  }

  @Watch("selectedVentMiddle")
  protected async selectVentMiddle(): Promise<void> {
    if (this.selectedVentMiddle === option.Panel.Solid) {
      this.selectedAlternatingVentType = null;
      this.addVentMiddle(option.Panel.Solid);
      if (this.ventMiddleFabric[1]) {
        this.addVentMiddleFabric([this.ventMiddleFabric[0]]);
        await this.$viewer.ChangeDblVentFabric(
          this.ventMiddleFabric[0].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[0])
        );
      }
    }
  }

  @Watch("selectedAlternatingVentType")
  protected async selectAlternatingVentType(): Promise<void> {
    if (!this.selectedAlternatingVentType) return;

    this.selectedVentMiddle = option.Panel.Alternating;
    this.addVentMiddle(option.Panel.Alternating);

    if (this.selectedAlternatingVentType === option.AlternatingPanel.Two && this.ventMiddleFabric[2]) {
        this.addVentMiddleFabric([this.ventMiddleFabric[0], this.ventMiddleFabric[1]]);
        await this.$viewer.ChangeDblVentFabric(
          this.ventMiddleFabric[0].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[0]),
          this.ventMiddleFabric[1].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[1])
        );
    }
  }


  @Watch("selectedRib")
  protected async selectRib(): Promise<void> {
    if (this.selectedRib) {
      const fabric = this.selectedRib === option.Rib.Grommets ? undefined : fabricTextureKey(this.mainFabric[0])
      const swatch = this.selectedRib === option.Rib.Grommets ? null : this.mainFabric[0];
      this.$viewer.ChangeRibAttachment(this.selectedRib, fabric)
      this.addRib(this.selectedRib);
      this.addRibFabric(swatch)
    }
    // If this change was from the user (not programmatic), clear auto-switch tracking
    if (!this.suppressRibWatch && this.ribAutoSwitchedToGrommets) {
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
    }
  }
}
